// extracted by mini-css-extract-plugin
export default {"quote":"UserQuote_quote__QMaOo","title":"UserQuote_title__YHYGg","info":"UserQuote_info__GzUnA"};